import ResourceCard, { type ChatResourceItem } from './ResourceCard';
import './resourcesCarousel.scss';
import './resourceCard.scss';

interface ResourcesCarouselProps {
  items: ChatResourceItem[];
  onVisitSource?: (item: ChatResourceItem) => void;
  onAddToPatient?: (item: ChatResourceItem) => void;
  showAddToPatient?: boolean;
}

const ResourcesCarousel = ({
  items,
  onVisitSource,
  onAddToPatient,
  showAddToPatient = false,
}: ResourcesCarouselProps) => {
  if (!items.length) return null;

  return (
    <div className="chat-resources" aria-label="Resources">
      <div className="chat-resources__track">
        {items.map((item) => (
          <div className="chat-resources__slide" key={item.entryId}>
            <ResourceCard
              item={item}
              onVisitSource={onVisitSource}
              onAddToPatient={onAddToPatient}
              showAddToPatient={showAddToPatient}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ResourcesCarousel;
